import { ColumnCardBase } from './ColumnCardBase';

export const ColumnCardGrid = ({ data, ...props }) => {
  return (
    <ColumnCardBase
      title={data.title}
      src={data.img_card}
      description={data.description}
      ctaSlug={data.cta_slug}
      ctaText={data.cta_text}
      altImg={data.alt_img}
      {...props}
    />
  );
};
